import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '@app/shared';
import { MaterialModule } from '@app/shared/material.module';
import { NavigationAddEditComponent, NavigationListComponent } from '@user/components/navigation';

const routes: Routes = [
  { path: 'list', component: NavigationListComponent, data: { title: 'Navigation List' } }
];
@NgModule({
  declarations: [NavigationAddEditComponent, NavigationListComponent],
  imports: [
    RouterModule.forChild(routes),
    MaterialModule,
    SharedModule
  ],
  entryComponents: [NavigationAddEditComponent]
})
export class NavigationModule { }
